import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, Instagram } from "lucide-react";
import { company } from "../data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-forest-deep text-bone">
    <div className="container-fl py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] text-bone">
            Fresh
            <br />
            Landscape Group
          </h2>
          <p className="mt-6 text-bone/60 max-w-md text-lg font-light">
            {company.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-clay mb-5">Explore</p>
          <ul className="space-y-3 text-bone/70">
            {[
              ["/hardscaping", "Hardscaping"],
              ["/snow-removal", "Snow Removal"],
              ["/lawn-maintenance", "Lawn Maintenance"],
              ["/outdoor-kitchens", "Outdoor Kitchens"],
              ["/gallery", "Gallery"],
              ["/contact", "Get a Quote"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="hover:text-clay transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-clay mb-5">Contact</p>
          <a
            href={company.phoneHref}
            data-testid="footer-phone"
            className="flex items-center gap-3 text-bone hover:text-clay transition-colors mb-4"
          >
            <Phone size={18} strokeWidth={1.5} /> {company.phone}
          </a>
          <p className="flex items-center gap-3 text-bone/70 mb-8">
            <MapPin size={18} strokeWidth={1.5} /> {company.location}
          </p>
          <div className="flex items-center gap-4">
            <a href={company.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-11 h-11 flex items-center justify-center border border-bone/20 hover:bg-clay hover:border-clay transition-colors">
              <Facebook size={18} />
            </a>
            <a href={company.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-11 h-11 flex items-center justify-center border border-bone/20 hover:bg-clay hover:border-clay transition-colors">
              <Instagram size={18} />
            </a>
            <a href={company.social.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="w-11 h-11 flex items-center justify-center border border-bone/20 hover:bg-clay hover:border-clay transition-colors text-sm font-semibold">
              TT
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-bone/10 flex flex-col md:flex-row justify-between gap-3 text-sm text-bone/50">
        <p>© {new Date().getFullYear()} Fresh Landscaping — All Rights Reserved.</p>
        <p>Full-service landscaping & snow removal, every season.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
